export const EPG_POWER_GUIDE_RECEIVED = '@ZAPI_EPG_ANONYMOUS_RECEIVED';
export const EPG_RECEIVED = '@ZAPI_EPG_RECEIVED';
export const EPG_POWER_DETAILS_RECEIVED = '@ZAPI_EPG_DETAILS_RECEIVE';
export const EPG_SEARCH_COMPLETED = '@ZAPI_EPG_SEARCH_COMPLETED';
export const EPG_GROUPED_SEARCH_COMPLETED = '@ZAPI_EPG_GROUPED_SEARCH_COMPLETED';
export const EPG_SERIES_DETAILS_RECEIVED = '@ZAPI_EPG_SERIES_DETAILS_RECEIVED';
export const EPG_SIMILAR_PROGRAMS_RECEIVED = '@ZAPI_EPG_SIMILAR_PROGRAMS_RECEIVED';
export const EPG_CONNECTED_CONTENTS_RECEIVED = '@ZAPI_EPG_CONNECTED_CONTENTS_RECEIVED';
export const EPG_POSITION_UPDATED = '@ZAPI_EPG_POSITION_UPDATED';
export const EPG_STATUSES_RECEIVED = '@ZAPI_EPG_STATUSES_RECEIVED';
